import { Button } from "@mantine/core";
import { Link, useNavigate } from "react-router";
import { useMessages } from "../i18n/provider";
import styles from "./legal.module.css";

type LegalKind = "privacy" | "terms" | "refunds";

const BODY: Record<LegalKind, "legal.privacyBody" | "legal.termsBody" | "legal.refundsBody"> = {
  privacy: "legal.privacyBody",
  terms: "legal.termsBody",
  refunds: "legal.refundsBody",
};

export function LegalPage({ kind }: { kind: LegalKind }) {
  const t = useMessages();
  const navigate = useNavigate();
  const title =
    kind === "privacy"
      ? t("legal.privacy")
      : kind === "terms"
        ? t("legal.terms")
        : t("legal.refunds");

  return (
    <div className={styles.root}>
      <main className={styles.main}>
        <Button
          variant="subtle"
          color="gray"
          size="sm"
          onClick={() => navigate(-1)}
          className={styles.back}
        >
          {t("common.back")}
        </Button>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.updated}>{t("legal.lastUpdated")}</p>
        <p className={styles.body}>{t(BODY[kind])}</p>
        <nav className={styles.links}>
          {kind !== "privacy" ? <Link to="/privacy">{t("legal.privacy")}</Link> : null}
          {kind !== "terms" ? <Link to="/terms">{t("legal.terms")}</Link> : null}
          {kind !== "refunds" ? <Link to="/refunds">{t("legal.refunds")}</Link> : null}
        </nav>
      </main>
    </div>
  );
}
